import React from "react";
import { Link } from "react-router-dom";

import { IoIosArrowDroprightCircle } from "react-icons/io";

import {
  wellness_diagnostics,
  wellness_teleconsultation,
  wellness_medicine,
  nutritionicon,
  wellness_doctor,
} from "../Assets";
import {
  APP_DIAGNOSTICS_URL,
  APP_MEDICINE_URL,
  APP_TELECONSULT_URL,
  APP_NUTRIOTION_URL,
} from "../Constants";
import { toast } from "react-toastify";

const WellnessFeatures = ({ appLinkToken }) => {
  return (
    <div className="wellness-features-main-cover-wrapper-rev">
      <div className="wellness-features-main-cover-box">
        <div className="dashboard-wellness-feature-title-box mt-0">
          <h5 className="dashboard-wellness-feature-title">Wellness Corner</h5>
        </div>
        <div className="dashboard-wellness-features-cover-wrapper">
          <div className="row d-flex align-items-center">
            <div className="col-lg-6 mb-4">
              <Link
                className={`wellness-card-link ${
                  !appLinkToken ? "disabled" : ""
                }`}
                to={
                  appLinkToken
                    ? `${APP_TELECONSULT_URL}?token=${appLinkToken}&href=${window.location.href}`
                    : "#"
                }
                onClick={(e) => {
                  if (!appLinkToken) {
                    e.preventDefault(); // Prevent navigation when appLinkToken is null
                    toast.error("App link token is missing. Cannot proceed.");
                  }
                }}
              >
                <div className="employee-benefit-wellness-cover">
                  <div className="employee-benefit-wellness-box">
                    <div className=" employee-benefit-wellness-box-icon">
                      <img src={wellness_teleconsultation} alt="nutrition" width="100%" />
                    </div>
                    <div className="employee-benefit-wellness-heading">
                      <span>Call a Doctor </span>
                    </div>
                  </div>
                </div>
              </Link>
            </div>
            <div className="col-lg-6 mb-4">
              <Link
                className={`wellness-card-link ${
                  !appLinkToken ? "disabled" : ""
                }`}
                to={
                  appLinkToken
                    ? `${APP_MEDICINE_URL}?token=${appLinkToken}&dept_id=10&href=${window.location.href}`
                    : "#"
                }
                onClick={(e) => {
                  if (!appLinkToken) {
                    e.preventDefault(); // Prevent navigation when appLinkToken is null
                    toast.error("App link token is missing. Cannot proceed.");
                  }
                }}
              >
                <div className="employee-benefit-wellness-cover">
                  <div className="employee-benefit-wellness-box">
                    <div className=" employee-benefit-wellness-box-icon">
                      <img src={wellness_medicine} alt="nutrition" width="100%" />
                    </div>
                    <div className="employee-benefit-wellness-heading">
                      <span>Medicines </span>
                    </div>
                  </div>
                </div>
              </Link>
            </div>
            <div className="col-lg-6 mb-4">
              <Link
                className={`wellness-card-link ${
                  !appLinkToken ? "disabled" : ""
                }`}
                to={
                  appLinkToken
                    ? `${APP_DIAGNOSTICS_URL}?token=${appLinkToken}&&href=${window.location.href}`
                    : "#"
                }
                onClick={(e) => {
                  if (!appLinkToken) {
                    e.preventDefault(); // Prevent navigation when appLinkToken is null
                    toast.error("App link token is missing. Cannot proceed.");
                  }
                }}
              >
                <div className="employee-benefit-wellness-cover">
                  <div className="employee-benefit-wellness-box">
                    <div className=" employee-benefit-wellness-box-icon">
                      <img src={wellness_diagnostics} alt="nutrition" width="100%" />
                    </div>
                    <div className="employee-benefit-wellness-heading">
                      <span>Diagnostic </span>
                    </div>
                  </div>
                </div>
              </Link>
            </div>
            <div className="col-lg-6 mb-4">
              <Link
                className={`wellness-card-link ${
                  !appLinkToken ? "disabled" : ""
                }`}
                to={
                  appLinkToken
                    ? `${APP_NUTRIOTION_URL}?token=${appLinkToken}&dept_id=10&href=${window.location.href}`
                    : "#"
                }
                onClick={(e) => {
                  if (!appLinkToken) {
                    e.preventDefault(); // Prevent navigation when appLinkToken is null
                    toast.error("App link token is missing. Cannot proceed.");
                  }
                }}
              >
                <div className="employee-benefit-wellness-cover">
                  <div className="employee-benefit-wellness-box">
                    <div className=" employee-benefit-wellness-box-icon">
                      <img src={nutritionicon} alt="nutrition" width="100%" />
                    </div>
                    <div className="employee-benefit-wellness-heading">
                      <span>Nutrition </span>
                    </div>
                  </div>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WellnessFeatures;
